export default __webpack_public_path__ + "static/media/ic_marshall_island.f36763f0.svg";